import { memo } from "react";

import { IconApps, IconKey } from "@tabler/icons";
import { useTheme } from "styled-components";

import { TableActions } from "@sso/components/TableActions";
import { Dialog } from "@sso/constant";
import { useAppDispatch } from "@sso/hooks/useRedux";
import { openDialog } from "@sso/store/slices/dialog";
import { Divider } from "@sso/ui/Divider";
import { IconButton } from "@sso/ui/IconButton";
import { TD } from "@sso/ui/Table";

interface UserTableActionsProps {
  userId: string;
}

export const UserTableActions = memo(({ userId: id }: UserTableActionsProps) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();

  const handleRemoveUser = () => {
    dispatch(openDialog({ type: Dialog.DELETE_USER, id }));
  };

  const handleEditUser = () => {
    dispatch(openDialog({ type: Dialog.EDIT_USER, id }));
  };

  const handleUserResetPassword = () => {
    dispatch(openDialog({ type: Dialog.USER_RESET_PASSWORD, id }));
  };

  const handleUserProduct = () => {
    dispatch(openDialog({ type: Dialog.USER_PRODUCT, id }));
  };

  return (
    <TD>
      <TableActions id={id} onEditClick={handleEditUser} onRemoveClick={handleRemoveUser}>
        <IconButton
          title="Apps"
          color={theme.colors.grey[400]}
          hoverColor={theme.colors.grey[700]}
          onClick={handleUserProduct}
        >
          <IconApps />
        </IconButton>
        <IconButton
          title="Reset Password"
          color={theme.colors.grey[400]}
          hoverColor={theme.colors.grey[700]}
          onClick={handleUserResetPassword}
        >
          <IconKey />
        </IconButton>
        <Divider direction="v" height="20px" />
      </TableActions>
    </TD>
  );
});
